import React from "react";
import ConfigSection from "../../ConfigSection";

const WorkTypeSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Work Type'
      configType='WorkType'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default WorkTypeSection;
